export const MAX_MONTHLY_SALES_AMOUNT = 9000000; // 9 000 000
export const MIN_MONTHLY_SALES_AMOUNT = 2500; // 2 500
export const MAX_FUNDING_AMOUNT = 1000000; // 1 000 000
export const FUNDING_COEFFICIENTE = 1.5;
